import React, { FC, useEffect, useMemo, useState } from 'react';
import { GxCheckbox, GxIcon, GxInput, GxTextarea, } from '@garpix/garpix-web-components-react';
import cn from 'classnames';
import 'react-responsive-modal/styles.css';
import Select, { SingleValue } from 'react-select';
import { useStoreon } from 'storeon/react';
import dayjs from 'dayjs';

import { Events, State } from '@/interfaces';
import { api } from '@/api';
import { IUser } from '@/types';
import { PlusIcon, UserIcon, UsersIcon } from '../../../../assets';
import InputsSession from '../../../../components/InputsSession';
import Switcher from '../../../../components/Switcher';
import { ORDERS, TYPE_USER } from '../../../../const';
import { defaultStyles, saleSourceOptions, TYPES_STATUS } from '../../consts';
import MultiSelectUsers from './components/MultiSelectUsers';
import SelectUser from './components/SelectUsers';
import {
  checkAutomaticStockOrder,
  checkManualStockMulti,
  checkManualStockOrder,
  installRatesList,
  installRatesListWithData,
  installRatesListByChildren
} from './helpers';
import { countPriceMulti } from '../../helpers';
import ModalUser from '../ModalUser';

import styles from './styles/index.module.scss';
import { IUserData } from './interfaces';

const ModalOrderData: FC<IUserData> = ({
  loadingUserDataAfterCreate,
  setLoadingUserDataAfterCreate,
  formik,
  data,
  date,
  selectedTypeOrder
}) => {

  const [isShowSportsmanSessionTime, setIsShowSportsmanSessionTime] = useState<
    boolean
  >(false);

  const {
    typeOrder,
    statusTransferOrder,
    statusCreateMultiOrders,
    arrayDateTimeOrders,
    currentUser,
    tariffs,
    dispatch
  } = useStoreon<State, Events>(
    'typeOrder',
    'currentUser',
    'statusTransferOrder',
    'statusCreateMultiOrders',
    'arrayDateTimeOrders',
    'tariffs'
  );

  const isMultiOrder = data?.pay_order.is_mass_booking || false;

  const [openModalCreate, setOpenModalCreate] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [userIdParticipant, setUserIdParticipant] = useState<null | number>(null);
  const [isCreateParticipant, setIsCreateParticipant] = useState(false);
  const [currentTypeOrder] = useState<ORDERS>(selectedTypeOrder || typeOrder)

  const closeModalUserParticipant = async () => {
    setUserIdParticipant(null);
    setOpenModalEdit(false);
    if (userIdParticipant) {
      const data = await api.user.getUser(userIdParticipant);
      formik.setFieldValue(
        'participants',
        [...formik.values.participants.filter((elem: any) => elem.id !== data.id), {
          ...data,
          value: data.id,
          label: `${data?.last_name || ''} ${data?.first_name || ''}`
        }]
      );
    }
  }

  const closeModalCreateOrEdit = () => {
    if (userIdParticipant) {
      closeModalUserParticipant()
    } else if (openModalCreate) {
      setOpenModalCreate(false)
    } else {
      setOpenModalEdit(false)
    }
  }

  const flagBtnAddPeople =
    formik.values.count_party === formik.values.participants.length;

  const openModalUserEdit = () => {
    setOpenModalEdit(true);
    setUserIdParticipant(null)
  };


  const openModalUserParticipant = (value: any) => {
    if (value?.id) {
      setUserIdParticipant(value?.id);
      setOpenModalEdit(true);
    }
  }

  const openModalUser = () => setOpenModalCreate(true);

  useEffect(() => {
    if ((Object.keys(tariffs).length || statusCreateMultiOrders) && !data) {
      installRatesList(
        formik,
        statusTransferOrder,
        statusCreateMultiOrders,
        tariffs,
        currentTypeOrder,
        arrayDateTimeOrders
      );
    }
    if (statusCreateMultiOrders) {
      formik.setFieldValue('base_price', countPriceMulti(arrayDateTimeOrders));
    }

  }, [formik.values.customer, tariffs, formik.values.is_children]);

  useEffect(() => {
    // меняем tariff_rate и price если меняется чекбокс "Дети"
    if (Object.keys(tariffs).length && data) {
      installRatesListByChildren(
        formik,
        statusTransferOrder,
        statusCreateMultiOrders,
        data,
        tariffs,
        currentTypeOrder
      );
    }
  }, [formik.values.is_children]);

  useEffect(() => {
    if (Object.keys(tariffs).length && !!data && formik.values.status === TYPES_STATUS['PAY_LOCAL']) {
      installRatesListWithData(
        formik,
        statusTransferOrder,
        statusCreateMultiOrders,
        data,
        tariffs,
        currentTypeOrder
      )
    }
  }, [formik.values.customer, tariffs, formik.values.tariff])

  useEffect(() => {
    if (data?.start_at && formik.values.start_at !== data?.start_at && !date) {
      dispatch('tariffRates/get', {
        date: dayjs(data?.start_at).format('YYYY.MM.DD'),
        time: dayjs(data?.start_at).format('HH:mm'),
        is_child: formik.values.is_children,
      });
    } else if (date && formik.values.start_at !== data?.start_at && !data?.start_at) {
      const dateWithoutTime = date.split(' ')[0]
      const onlyTime = date.split(' ')[1]
      dispatch('tariffRates/get', {
        date: dateWithoutTime,
        time: onlyTime,
        is_child: formik.values.is_children,
      });
    }
  }, [formik.values.customer, data, date]);

  useEffect(() => {
    if (formik.values?.is_sport) {
      setIsShowSportsmanSessionTime(
        formik.values?.is_sport
      )
    } else if (formik.values?.customer) {
      if (currentTypeOrder === 1) {
        setIsShowSportsmanSessionTime(
          formik.values?.customer?.tube_user_type_is_sport || formik.values?.customer?.tube_user_type.is_sport
        )
      } else if (currentTypeOrder === 2) {
        setIsShowSportsmanSessionTime(
          formik.values?.customer.wave_user_type_is_sport || formik.values?.customer?.wave_user_type.is_sport
        )
      }
    }
  }, [formik.values?.tariff?.tariff_rates, formik.values.customer]);


  const onChangeOption = (selectedOption: any) => {
    formik.setValues({
      ...formik.values,
      customer: selectedOption && selectedOption,
      participants: selectedOption && [selectedOption],
      discount: true,
      stock_name: null,
      price_stock: 0,
      manual_stock: null,
      is_automatic_stock: true,
      stock: null,
      tariff_rate: {
        price: 0,
        strikeout_price: null,
        count_people: 0,
        minutes: 0,
        id: null,
      }
    })

    formik.setTouched({ 'customer': true })

    if (!selectedOption) {
      formik.setFieldValue('participants', []);
      formik.setFieldValue('multiRates', []);
      formik.setFieldValue('tariff_rate_multi', {
        value: 0,
        label: null,
      });
    }

    if (selectedOption) {
      dispatch('selectedUser/set', {
        ...selectedOption,
        value: selectedOption?.id,
        label: `${selectedOption?.last_name || ''} ${selectedOption?.first_name || ''} ${selectedOption?.phone || ''}`,
      });
    } else {
      dispatch('selectedUser/set', undefined);
    }
  }

  const onChangeValue = async (dataUser: any) => {
    setLoadingUserDataAfterCreate(true);
    try {
      const response = await api.user.getUsers({
        page: 1,
        search: `${dataUser.first_name} ${dataUser.last_name}`
      });
      const userKey = ORDERS.PIPE === currentTypeOrder ? 'acceptance_date_for_airtube' : 'acceptance_date_for_wave'

      const filteredOptions = response.results.map((el) => {
        return {
          value: el.id,
          label: `${el.last_name || ''} ${el.first_name || ''} ${el.phone || ''}`,
          color: el[userKey as keyof IUser] !== null ? 'green' : 'red',
          ...el
        };
      });

      const selectedOption = filteredOptions.find((el) => el.id === dataUser.id);

      if (selectedOption) {
        onChangeOption(selectedOption);
      } else {
        onChangeOption(filteredOptions[0]);
      }

    } finally {
      setLoadingUserDataAfterCreate(false);
    }
  };

  const changeMinutes = (selectedOption: any) => {
    // const participantValues = formik.values.participants;
    // const customerId = formik.values.customer?.id
    // if (selectedOption.count_people < participantValues.length) {
    //   const valuesCustomer = participantValues.find((elem: any) => elem?.id === customerId);
    //   const filterValues = participantValues.filter((elem: any) => elem?.id !== customerId) || [];
    //   const formattedValues = valuesCustomer ? [valuesCustomer, ...filterValues.splice(0, selectedOption.count_people - 1)] : participantValues.splice(0, selectedOption.count_people)
    //   formik.setFieldValue(
    //       'participants',
    //       formattedValues
    //   );
    // }
    if (statusCreateMultiOrders) {
      formik.setFieldValue(
        'tariff_rate_multi',
        selectedOption && selectedOption
      );
    } else {
      formik.setFieldValue('count_party', {
        value: selectedOption.count_people,
        title: selectedOption.title,
      });
      formik.setFieldValue(
        'tariff_rate',
        selectedOption && selectedOption
      );
      formik.setFieldValue(
        'price',
        selectedOption && selectedOption.price
      );
      formik.setFieldValue(
        'base_price',
        Math.trunc(Number(selectedOption.price))
      );
    }
  }

  useMemo(() => {
    if (
      statusCreateMultiOrders &&
      arrayDateTimeOrders.length > 0 &&
      formik.values.manual_stock
    ) {
      checkManualStockMulti(
        arrayDateTimeOrders,
        formik.values.manual_stock,
        formik,
        currentUser,
      );
    } else if (formik.values.manual_stock) {
      checkManualStockOrder(
        formik,
        formik.values.manual_stock,
        currentUser,
        currentTypeOrder
      );
    } else if (formik.values.is_automatic_stock && formik.values.discount && formik.values.tariff_rate?.id && data) {
      checkAutomaticStockOrder(
        formik,
        date,
        currentUser
      );
    }
  }, [formik.values.base_price, formik.values.manual_stock, formik.values.customer, formik.values.is_automatic_stock])

  const setParticipant = (selectedOption: Record<string, any>) => {
    if (formik.values.tariff_rate.count_people !== 1 && formik.values.participants) {
      formik.setFieldValue(
        'participants',
        [
          ...formik.values.participants,
          selectedOption && selectedOption
        ]
      );

    }
  };

  const PAY_LOCAL_CONDITION = data?.status === TYPES_STATUS.PAY_LOCAL ? false : (
    !!data ||
    statusTransferOrder ||
    arrayDateTimeOrders.length > 0 ||
    currentUser.user_status === TYPE_USER.VIEWER
  );

  return (
    <div className={styles['blank']}>
      <div className={styles['blank--wrapper']}>
        <div className={styles['blank--item']}>
          <div className={styles['blank--group']}>
            <label className={styles['blank--item_label']} htmlFor='customer'>
              Контрагент:
            </label>
            <SelectUser
              maxWidth="428"
              value={formik.values.customer}
              flagDisabled={PAY_LOCAL_CONDITION || isMultiOrder}
              onChange={(
                selectedOption: SingleValue<any>
              ) => {
                onChangeOption(selectedOption);
              }}
            />
          </div>
          {formik.values.customer ? (
            <button
              type="button"
              className={styles['btn--check-user']}
              onClick={openModalUserEdit}
              disabled={loadingUserDataAfterCreate}
            >
              <GxIcon
                className={styles['btn--icon-check-user']}
                src={UserIcon}
              />
            </button>
          ) : (
            <button
              type='button'
              className={styles['btn--add-user']}
              disabled={currentUser.user_status === TYPE_USER.VIEWER}
              onClick={openModalUser}
            >
              <GxIcon className={styles['btn--icon-plus']} src={PlusIcon} />
            </button>
          )}
        </div>
        {formik.errors.customer && (
          <div className={styles['error']}>Необходимо выбрать значение</div>
        )}
        <div className={cn(styles['blank--item'], styles['blank--item_left'])}>
          <div className={styles['blank--group']}>
            <label className={styles['blank--item_label']} htmlFor='source'>
              Источник:
            </label>
            <Select
              isClearable
              aria-labelledby='label-source'
              placeholder='Выберите'
              value={formik.values.source}
              options={saleSourceOptions}
              name='source'
              menuPlacement='auto'
              className={styles['item-select']}
              styles={defaultStyles}
              isDisabled={
                data?.status === TYPES_STATUS.PAY_LOCAL ? false : (
                  !!data ||
                  statusTransferOrder ||
                  currentUser.user_status === TYPE_USER.VIEWER
                )}
              onChange={(
                selectedOption: SingleValue<{ value: number; label: string }>
              ) =>
                formik.setFieldValue('source', selectedOption && selectedOption)
              }
            />
          </div>
        </div>
        {!statusCreateMultiOrders && (
          <div
            className={cn(styles['blank--item'], styles['blank--item_left'])}
          >
            <div className={styles['blank--group']}>
              <GxInput
                label='Тариф:'
                name='tariff'
                value={formik.values.tariff.label}
                className={styles['item-input']}
                disabled
                onGx-change={(e: Record<string, any>) =>
                  formik.setFieldValue('tariff', e.target.value)
                }
              />
            </div>
          </div>
        )}
        {(formik.values.side ?? currentTypeOrder) === ORDERS.WAVE && (
          <div className={styles['blank--item']}>
            <div className={styles['blank--group']}>
              <label
                className={styles['blank--item_label']}
                htmlFor='label-count'
              >
                Количество:
              </label>
              <Select
                value={
                  statusCreateMultiOrders
                    ? {
                      value: formik.values.tariff_rate_multi
                        ? formik.values.tariff_rate_multi.value
                        : 0,
                      label: formik.values.tariff_rate_multi
                        ? formik.values.tariff_rate_multi.label
                        : '0 чел.',
                    }
                    : {
                      value: formik.values.tariff_rate.count_people
                        ? formik.values.tariff_rate.count_people
                        : 0,
                      label: `${formik.values.tariff_rate.count_people
                        ? formik.values.tariff_rate.count_people
                        : 0
                        } чел.`,
                    }
                }
                aria-labelledby='label-count'
                options={
                  statusCreateMultiOrders
                    ? formik.values.multiRates
                    : formik.values.tariff_rates
                }
                onChange={(selectedOption: any) => {
                  if (statusCreateMultiOrders) {
                    formik.setFieldValue(
                      'tariff_rate_multi',
                      selectedOption && selectedOption
                    );
                  } else {
                    formik.setFieldValue('count_party', {
                      value: selectedOption.count_people,
                      title: selectedOption.title,
                    });
                  }
                  formik.setFieldValue(
                    'tariff_rate',
                    selectedOption && selectedOption
                  );
                  if (!statusCreateMultiOrders)
                    formik.setFieldValue(
                      'base_price',
                      Math.trunc(Number(selectedOption.price))
                    );
                }}
                isDisabled={PAY_LOCAL_CONDITION}
                name='count_party'
                className={cn(
                  styles['item-select'],
                  styles['item-select--count']
                )}
                styles={defaultStyles}
                noOptionsMessage={() => '---'}
              />
            </div>
          </div>
        )}
        {(formik.values.side ?? currentTypeOrder) === ORDERS.PIPE && (
          <div className={styles['blank--item']}>
            <div className={styles['blank--group']}>
              <label
                className={styles['blank--item_label']}
                htmlFor='label-count'
              >
                Минуты
              </label>
              <div className={styles['users-minutes']}>
                <Select
                  value={
                    statusCreateMultiOrders
                      ? {
                        value: formik.values.tariff_rate_multi
                          ? formik.values.tariff_rate_multi.value
                          : 0,
                        label: formik.values.tariff_rate_multi
                          ? formik.values.tariff_rate_multi.label
                          : '0 мин.',
                      }
                      : {
                        value: formik.values.tariff_rate.minutes
                          ? formik.values.tariff_rate.minutes
                          : 0,
                        label: `${formik.values.tariff_rate.minutes
                          ? formik.values.tariff_rate.minutes
                          : 0
                          } мин.`,
                      }
                  }
                  aria-labelledby='label-count'
                  options={
                    statusCreateMultiOrders
                      ? formik.values.multiRates
                      : formik.values.tariff_rates
                  }
                  onChange={changeMinutes}
                  isDisabled={PAY_LOCAL_CONDITION}
                  name='minutes'
                  className={cn(
                    styles['item-select'],
                    styles['item-select--count']
                  )}
                  styles={defaultStyles}
                  noOptionsMessage={() => '---'}
                />
                <div className={styles['users']}>
                  {!statusCreateMultiOrders && (
                    <>
                      <GxIcon
                        className={styles['users--icon']}
                        src={UsersIcon}
                      />
                      <span>{formik.values.tariff_rate.count_people}</span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {currentTypeOrder === ORDERS.PIPE && isShowSportsmanSessionTime && (
          <div className={styles['blank--item']}>
            <div className={styles['blank--group']}>
              <p className={styles['blank--item_label']}>Сессия:</p>
              <InputsSession
                name="session_minutes"
                value={formik.values.session_minutes}
                disable={PAY_LOCAL_CONDITION}
                changeSession={(session_minutes) =>
                  formik.setFieldValue('session_minutes', session_minutes)
                }
              />
            </div>
          </div>
        )}
        <div className={cn(styles['blank--item'], styles['blank--item_left'])}>
          <GxTextarea
            label='Комментарий:'
            name='note'
            resize='none'
            value={formik.values.comment}
            className={styles['item-input']}
            onGx-change={(e: any) =>
              formik.setFieldValue('comment', e.target.value)
            }
            onGx-input={(e: any) =>
              formik.setFieldValue('comment', e.target.value)
            }
            disabled={
              currentUser.user_status === TYPE_USER.VIEWER
            }
          />
        </div>
        <div className={cn(styles['blank--item'])}>
          <GxCheckbox
            name='is_children'
            value={formik.values.is_children}
            className={styles['item-children']}
            checked={formik.values.is_children}
            disabled={PAY_LOCAL_CONDITION}
            onGx-change={(e: any) => {
              formik.setFieldValue('is_children', e.target.checked);
            }}
          >
            Дети
          </GxCheckbox>
        </div>
        {!statusCreateMultiOrders && (
          <div className={styles['members']}>
            <div className={styles['members--head']}>
              <label className={styles['members--label']} htmlFor='label-users'>
                Участники:
              </label>
              <Switcher
                label="Прибытие"
                checked={formik.values.is_arrived}
                onGx-change={() =>
                  formik.setFieldValue('is_arrived', !formik.values.is_arrived)
                }
                disabled={
                  data?.status === TYPES_STATUS.PAY_LOCAL ? false : (
                    (!!data && data.status === TYPES_STATUS.CLOSE) ||
                    currentUser.user_status === TYPE_USER.VIEWER
                  )}
              />
            </div>
            <div className={styles['members--block']}>
              <div>
                <MultiSelectUsers
                  menuPlacement="top"
                  width={580}
                  value={formik.values.participants}
                  isDisabled={
                    (!!data && data.status === TYPES_STATUS.CLOSE) ||
                    currentUser.user_status === TYPE_USER.VIEWER}
                  countMax={formik.values.tariff_rate.count_people}
                  onClickSingleValue={openModalUserParticipant}
                  onChange={(selectedOption: Record<string, any>) => {
                    formik.setFieldValue(
                      'participants',
                      selectedOption && selectedOption
                    );
                  }}
                />
              </div>
              <button
                type='button'
                className={styles['btn--add-user']}
                disabled={
                  statusTransferOrder ||
                  flagBtnAddPeople ||
                  (!!data && data.status === TYPES_STATUS.CLOSE) ||
                  currentUser.user_status === TYPE_USER.VIEWER
                }
                onClick={() => {
                  setIsCreateParticipant(true)
                  openModalUser()
                }}
              >
                <GxIcon className={styles['btn--icon-plus']} src={PlusIcon} />
              </button>
            </div>
          </div>
        )}
      </div>
      {openModalEdit || openModalCreate ? (
        <ModalUser
          props={{ isEdit: !openModalCreate, userId: userIdParticipant || formik?.values?.customer?.id }}
          isCreateParticipant={isCreateParticipant}
          setIsCreateParticipant={setIsCreateParticipant}
          setParticipant={setParticipant}
          flag={openModalEdit || openModalCreate}
          onRequestClose={closeModalCreateOrEdit}
          onChangeAfterCreateUser={(selectedOption) => {
            onChangeValue(selectedOption)
          }}
        />
      ) : ''}
    </div>
  );
};

export default ModalOrderData;
